import { render } from "./CheckboxField.vue?vue&type=template&id=45dfadf2"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"
script.render = render

export default script